import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import type {Preset} from '../../../../types'

export const API_PASSPORT = {
  [CSP.CONNECT]: [hostByBrandByEnv.yango.testing.passport.api],
} as const satisfies Preset
